export interface StockItemHeader {
  id: string;
  purchaseOrderLineId: string;
  purchaseOrderAndLineNo: string;
  purchaseInvoiceNo: number;
  externalNo: string;
  stockNo: string;
  qtyIn: number;
  valueIn: number;
  price: number;
  batchNo: string;
}
